module.exports = __webpack_public_path__ + "img/ru.47b9d7de.svg";